import React from 'react';

const SVG = ({ width = '12px', height = '12px', className = '', viewBox = '0 0 8 12', color = '#d94a52' }) => (
  <svg height={height} width={width} viewBox={viewBox} className={className}>
    <path fill={color} d="M8.5 7.793l2.828-2.829.708.708L9.207 8.5l2.829 2.828-.708.708L8.5 9.207l-2.828 2.829-.708-.708L7.793 8.5 4.964 5.672l.708-.708zm7.3.707a7.3 7.3 0 1 1-7.3-7.3 7.3 7.3 0 0 1 7.3 7.3zm-1 0a6.3 6.3 0 1 0-6.3 6.3 6.307 6.307 0 0 0 6.3-6.3z"/>
    <path fill="none" d="M0 0h16v16H0z"/>
  </svg>
);

export default SVG;
